import callWebApi from './callWebApi';
import {
  API_ACCOUNT_BANK_LINKS_URL,
  API_ACCOUNT_BANK_LINK_URL,
  API_USER_DETAIL_URL,
  replacePlaceholders,
} from './urls';

import { createFetchActionCreator } from './index';


export const BANK_LINK_CREATE = 'BANK_LINK_CREATE';
export const BANK_LINK = 'BANK_LINK';
export const BANK_LINK_CANCEL = 'BANK_LINK_CANCEL';
export const BANK_LINK_DISCLAIMER = 'BANK_LINK_DISCLAIMER';
export const BANK_LINK_PLAID_EVENT = 'BANK_LINK_PLAID_EVENT';
export const BANK_LINK_PLAID_INFO = 'BANK_LINK_PLAID_INFO';
export const BANK_LINK_SIGNATURE = 'BANK_LINK_SIGNATURE';
export const BANK_LINK_COMPLETED = 'BANK_LINK_COMPLETED';


export const fetchAccountBankLinks = accountNumber => async (dispatch, getState) => {
  const url = replacePlaceholders(API_ACCOUNT_BANK_LINKS_URL, { accountNumber });
  const fn = createFetchActionCreator(url, 'accountBankLinks', { accountNumber })();
  return fn(dispatch, getState);
};

export const createBankLink = (
  accountNumber,
  plaidInfo,
  customerAgreementSignatureData,
  customerAgreementSignatureImageEncoding,
) => async (dispatch, getState) => {
  const { authToken } = getState();
  dispatch({ type: `${BANK_LINK_CREATE}/REQUESTED` });

  const url = replacePlaceholders(API_ACCOUNT_BANK_LINKS_URL, { accountNumber });
  const body = {
    accountNumber,
    plaidInfo,
    customerAgreementSignatureData,
    customerAgreementSignatureImageEncoding,
  };

  const { bankLinkId } = await callWebApi('POST', url, body, authToken);
  dispatch({ type: `${BANK_LINK_COMPLETED}` });
  return bankLinkId;
};

export const cancelBankLink = (
  accountNumber,
  bankLinkId,
) => async (dispatch, getState) => {
  const { authToken } = getState();
  dispatch({ type: `${BANK_LINK_CANCEL}/REQUESTED` });
  const url = replacePlaceholders(
    API_ACCOUNT_BANK_LINK_URL,
    { accountNumber, bankLinkId },
  );
  const body = { status: 'C' };
  await callWebApi('PUT', url, body, authToken);
  dispatch({ type: `${BANK_LINK_CANCEL}/SUCCEED` });
};

export const bankLinkDisclaimer = bankLinkDisclaimerStatus => (async dispatch => (
  dispatch({ type: BANK_LINK_DISCLAIMER, bankLinkDisclaimerStatus })
));

export const bankLinkPlaidInfo = plaidInfo => (async dispatch => (
  dispatch({ type: BANK_LINK_PLAID_INFO, plaidInfo })
));

export const bankLinkSignature = (signatureImage, signatureImageEncoding) => (async dispatch => (
  dispatch({ type: BANK_LINK_SIGNATURE, signatureImage, signatureImageEncoding })
));

export const bankLinkPlaidEvent = (eventName, metadata) => async (dispatch, getState) => {
  dispatch({ type: `${BANK_LINK_PLAID_EVENT}/SAVING`, eventName });
  const { authToken, authTokenUser } = getState();
  const url = replacePlaceholders(API_USER_DETAIL_URL, { userId: authTokenUser.id });
  const body = {
    segmentInfo: {
      ...metadata,
    },
    segmentType: `${BANK_LINK_PLAID_EVENT}/${eventName}`,
    segmentSection: BANK_LINK,
  };
  const res = await callWebApi('POST', url, body, authToken);
  dispatch({ type: `${BANK_LINK_PLAID_EVENT}/SAVED`, userDetails: res });
  return res;
};



// WEBPACK FOOTER //
// ./src/actions/bankLinks.js